import HttpCliente from "servicios/HttpCliente";
import axios from "axios";
import getResponseError from "utils/getResponseError";

//FUNCION PARA NO PEDIR TOKEN DE SEGURIDAD EN LA PETICION
const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;

export const CntContratoModel = {
    id: undefined,
    codigo: '',
    empresaId: '',
    titulo: '',
    descripcion: '',
    monto: 0,
    cntContraparteId: 0,
    cntContactoContraparteId: 0,
    cntCategoriaContratoId: 0,
    cntTipoContratoId: 0,
    cntFormaPagoId: 0,
    cntEstadoContratoId: undefined,
    cntContratanteId: undefined,
    cntMonedaId: 0,
    fechaInicio: new Date(),
    fechaFin: new Date(),
    fechaFirma: new Date(),
    fechaRenovacion: new Date(),
    duenoContratoId: undefined,
    representantesLegalesIds: [],
    cntTipoRenovacionId: 0,
    visacion: 0,
    diasAvisoPrevio: 0,
    usuariosAprobadores: [],
    penalizacionesIds: []
}

export const TabDetalleContratoProps = {
    id: undefined,
    codigo: '',
    titulo: '',
    descripcion: '',
    fechaRenovacion: undefined
    //   empresa: { id: '', nombre: '' },
    //   gerencia: { id: 0, nombre: '' },
    //   area: { id: 0, nombre: '' },
    //   duenoActivo: { id: '', nombre: '' },
    //   tipoActivo: { id: 0, nombre: '' },
    //   confidencialidad: { id: 0, nombre: '', valor: 0 },
    //   integridad: { id: 0, nombre: '', valor: 0 },
    //   disponibilidad: { id: 0, nombre: '', valor: 0 },
    //   ubicacionActivo: { id: 0, nombre: '' },
    //   formatoActivo: { id: 0, nombre: '' },
};

export const ConversionDiariaContratoModel = {
    contratoId: undefined,
    cntMoneda: undefined,
};

export const FinalizacionContratoModel = {
    contratoId: undefined,
    comentario: '',
    modalidadAviso: '',
    fechaFin: new Date(),
};

export const RenovarContratoModel = {
    contratoId: undefined,
    comentario: '',
    nuevaFechaRenovacion: new Date(),
};

export const TabDetalleContratoRevisionProps = {
    id: undefined,
    codigo: '',
    titulo: '',
    descripcion: '',
    UsuarioEvalLink: [],
    //   empresa: { id: '', nombre: '' },
    //   gerencia: { id: 0, nombre: '' },
    //   area: { id: 0, nombre: '' },
    //   duenoActivo: { id: '', nombre: '' },
    //   tipoActivo: { id: 0, nombre: '' },
    //   confidencialidad: { id: 0, nombre: '', valor: 0 },
    //   integridad: { id: 0, nombre: '', valor: 0 },
    //   disponibilidad: { id: 0, nombre: '', valor: 0 },
    //   ubicacionActivo: { id: 0, nombre: '' },
    //   formatoActivo: { id: 0, nombre: '' },
    esAprobador: false,
    esCreador: false,
};


/**
 * POST method - Crear un nuevo contrato
 * @param {CntContratoModel} contrato contrato
 * @param {FileList} archivos archivos
 * @return {Promise} Promesa de creación
 */
export const crearCntContrato = (contrato, archivos) => {
    return new Promise((resolve, eject) => {
        const formData = new FormData();
        var jsonData = JSON.stringify(contrato);

        if (archivos) {
            for (let i = 0; i < archivos.length; i++) {
                formData.append('files', archivos[i]);
            }
        } else {
            formData.append('files', null);
        }
        formData.append('jsonData', jsonData);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        HttpCliente.post('/CntContrato', formData, config)
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
}


export const actualizarContrato = (contrato, archivos) => {
    return new Promise((resolve, eject) => {
        const formData = new FormData();
        var jsonData = JSON.stringify(contrato);
        if (archivos) {
            for (let i = 0; i < archivos.length; i++) {
                formData.append('files', archivos[i]);
            }
        } else {
            formData.append('files', null);
        }
        formData.append('jsonData', jsonData);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        HttpCliente.put('/CntContrato', formData, config)
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};


/**
 * POST method - Registra finalizacion de contrato
 * @param {FinalizacionContratoModel} data datos de finalizacion
 * @return {Promise} Promesa de creación
 */
export const finalizarContrato = (data) => {
    return new Promise((resolve, eject) => {
        const formData = new FormData();
        var jsonData = JSON.stringify(data);

        formData.append('jsonData', jsonData);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        HttpCliente.post("/CntContrato/finalizar", formData, config)
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

/**
 * GET method - Obtiene un contrato por Id
 * @param {string} contratoId ID del contrato
 * @return {Promise} Promesa de obtención
 */
export const obtenerCntContrato = (contratoId) => {
    return new Promise((resolve, eject) => {
        HttpCliente.get("/CntContrato/" + contratoId)
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
}

/**
 * GET method - Obtiene un contrato por Id
 * @param {string} contratoId ID del contrato
 * @return {Promise} Promesa de obtención
 */
export const obtenerCntContratoRevision = (contratoId) => {
    return new Promise((resolve, eject) => {
        HttpCliente.get("/CntContrato/revision/" + contratoId)
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
}

export const obtenerConversionDiariaContrato = (contratoId, conversionId) => {
    return new Promise((resolve, eject) => {
        HttpCliente.get("/CntContrato/conversionActual/contrato/"+contratoId+"/conversion/"+conversionId)
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
}



/**
 * POST method - Obtiene una lista paginada con todos los contratos filtrados por nombre
 * @param {number} pagina N° de página a recuperar
 * @param {number} cantElementos Cantidad de elementos por página
 * @param {string} contrato Titulo del contrato
 * @param {string} orderBy Columna de orden
 * @param {string} orderDirection Dirección de orden asc o desc
 * @return {Promise} Promesa de obtención
 */

export const paginacionContratos = (pagina, cantElementos, contrato, tipoContratoId, monedaId, empresaId, filtro, orderBy = "", orderDirection = "") => {
    return new Promise((resolve, eject) => {
        HttpCliente.post('/CntContrato/report', {
            PageNumber: pagina,
            PageSize: cantElementos,
            Contrato: contrato,
            MonedaId: monedaId,
            TipoContratoId: tipoContratoId,
            EmpresaId: empresaId,
            OrderBy: orderBy,
            Filtro: filtro,
            OrderDirection: orderDirection,
        })
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch(error => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

/**
 * POST method - Obtiene una lista paginada con todos los contratos filtrados por nombre
 * @param {number} pagina N° de página a recuperar
 * @param {number} cantElementos Cantidad de elementos por página
 * @param {string} contrato Titulo del contrato
 * @param {string} orderBy Columna de orden
 * @param {string} orderDirection Dirección de orden asc o desc
 * @return {Promise} Promesa de obtención
 */

export const paginacionMisContratos = (pagina, cantElementos, contrato, orderBy = "", orderDirection = "") => {
    return new Promise((resolve, eject) => {
        HttpCliente.post('/CntMiContrato/report', {
            PageNumber: pagina,
            PageSize: cantElementos,
            Contrato: contrato,
            OrderBy: orderBy,
            OrderDirection: orderDirection,
        })
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch(error => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

/**
 * POST method - Obtiene una lista paginada con todos los oficios (usado para listas desplegables)
 * @param {number} pagina N° de página a recuperar
 * @param {number} cantElementos Cantidad de elementos por página
 * @param {string} contrato Nombre del contrato
 * @param {string} contratoId Id del contrato
 * @return {Promise} Promesa de obtención
 */
export const paginacionContratoLista = (pagina, cantElementos, contrato = "", contratoId) => {
    return new Promise((resolve, eject) => {
        HttpCliente.post("/CntContrato/reportLista", {
            PageNumber: pagina,
            PageSize: cantElementos,
            Contrato: contrato,
            ContratoId: (contratoId !== "" && contratoId !== "todo") ? contratoId : undefined,
        })
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch(error => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

/**
 * GET method - Obtiene estadisticas de mis contratos
 * @return {Promise} Promesa de obtención
 */
export const obtenerEstadisticasMisContratos = () => {
    return new Promise((resolve, eject) => {
        HttpCliente.post("/CntMiContrato/estadisticas", {})
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

/**
 * POST method - Obtiene una lista paginada con todos los contratos filtrados por nombre
 * @param {number} pagina N° de página a recuperar
 * @param {number} cantElementos Cantidad de elementos por página
 * @param {string} contrato Titulo del contrato
 * @param {string} orderBy Columna de orden
 * @param {string} orderDirection Dirección de orden asc o desc
 * @return {Promise} Promesa de obtención
 */

export const paginacionContratosRevision = (pagina, cantElementos, contrato, orderBy = "", orderDirection = "") => {
    return new Promise((resolve, eject) => {
        HttpCliente.post('/CntContrato/revision/report', {
            PageNumber: pagina,
            PageSize: cantElementos,
            Contrato: contrato,
            OrderBy: orderBy,
            OrderDirection: orderDirection,
        })
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch(error => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

export const obtenerEstadisticasContratosAdministrador = (tipoContratoId = 0, empresaSelecc) => {
    return new Promise((resolve, eject) => {
        HttpCliente.post("/CntContrato/estadisticas/administrador", {
            CntTipoContratoId: tipoContratoId,
            EmpresaId: empresaSelecc
        })
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

export const obtenerArchivoContrato = (archivoId) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/CntContrato/archivo/" + archivoId, {
            responseType: 'blob'
        })
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
}

/**
 * GET method - Obtiene una lista con todos los contratos
 * @return {Promise} Promesa de obtención
 */
export const obtenerContratos = () => {
    return new Promise((resolve, eject) => {
        HttpCliente.get("CntContrato")
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch((error) => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};

/**
 * DELETE method - Elimina un contrato
 * @return {Promise} Promesa de eliminación
 */
export const eliminarCntContrato = (contratoId) => {
    return new Promise((resolve, eject) => {
        HttpCliente.delete(`/CntContrato/${contratoId}`)
            .then((response) => {
                resolve([response, undefined, response.status]);
            })
            .catch(error => {
                const err = getResponseError(error);
                resolve([undefined, err, error.response?.status]);
            });
    });
};